<template>
  <vx-card>
    <h4 class="mb-2">Workplace Safety</h4>
    <p class="my-5">You can view your student's Workplace Safety Certificate(s) below.</p>

    <h5 class="my-5">Workplace Safety Certificate</h5>

    <button
      class="my-5 btn btn-primary btn-size-medium includedIcon"
      @click="showWorkExperience()"
      v-if="prework.workplace_safety_url != ''"
    >
      <download-icon />
      View Certificate
    </button>
    <p class="mb-5" v-else>Student hasn't uploaded a Workplace Safety Certificate yet.</p>

    <h5 class="my-5">Other Workplace Safety Certificates</h5>
    <div class="other_certificates" v-if="showOtherCertificates">
      <div
        class="file_wrapper"
        v-for="(certificate, index) in prework.workplace_safety_url_other"
        :key="certificate.name"
      >
        <p class="file_name">{{ index + 1 }}. {{ certificate.name }}</p>
        <div class="file_actions">
          <a
            :href="certificate.url"
            target="_blank"
            class="btn btn-primary btn-size-small includedIcon"
          >
            <download-icon />
            View Certificate
          </a>
        </div>
      </div>
    </div>
    <p class="mb-5" v-else>Student hasn't uploaded other Workplace Safety Certificates yet.</p>
    <router-link
      class="inline-block mt-5 btn btn-secondary btn-size-medium"
      :to="'/teacher/vje/activity/student/' + this.$route.params.id"
    >
      Back
    </router-link>
  </vx-card>
</template>

<script>
import theApi from '@/mixins/theApi';
import store from '@/store/store';
import { DownloadIcon } from 'vue-feather-icons';

export default {
  components: { DownloadIcon },
  computed: {
    showOtherCertificates() {
      return (
        typeof this.prework.workplace_safety_url_other !== 'undefined' &&
        this.prework.workplace_safety_url_other !== null &&
        this.prework.workplace_safety_url_other.length > 0
      );
    },
  },
  data() {
    return {
      prework: false,
    };
  },
  methods: {
    async loadStudents() {
      theApi.methods.makeCall(true, 'vje_students/student/' + this.$route.params.id, 'get').then(
        (data) => {
          this.prework = data.data.prework;
        },
        () => {},
      );
    },
    showWorkExperience() {
      store.dispatch('popup/showIframePopup', this.prework.workplace_safety_url);
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>

<style scoped>
.other_certificates {
  overflow: hidden;
}

p.file_name {
  float: left;
  width: 80%;
  padding: 5px 0;
}

.file_wrapper {
  overflow: hidden;
  /* margin: 10px 0; */
}

.file_actions {
  float: left;
  margin: 10px 0;
}
</style>
